function FloatingModal({
  children,
  height = "auto",
  minHeight = 48,
  bottom = 128,
  padding = 24,
  gap = 15,
  borderRadius = 32,
  zIndex = 9999,
  background = "var(--surface-tertiary)",
  backdropFilter = "blur(12.5px)",
  direction = "row",
  alignItems = "center",
  justifyContent = "flex-start",
  contentStyle = {},
  wrapperStyle = {},
  onClickOutside,
}) {
  return (
    <>
      {onClickOutside ? (
        <div
          style={{ position: "fixed", inset: 0, zIndex: zIndex - 1 }}
          onClick={onClickOutside}
        />
      ) : null}
      <div
        style={{
          position: "fixed",
          left: "50%",
          bottom,
          transform: "translateX(-50%)",
          zIndex,
          pointerEvents: "none",
          ...wrapperStyle,
        }}
      >
        <div
          style={{
            pointerEvents: "auto",
            padding,
            background,
            borderRadius,
            backdropFilter,
            display: "flex",
            flexDirection: direction,
            alignItems,
            justifyContent,
            gap,
            height,
            minHeight,
            ...contentStyle,
          }}
        >
          {children}
        </div>
      </div>
    </>
  );
}

export default FloatingModal;
